export default [
  {
    path: "",
    mobilePath: "/homeIndex",
    redirect: "avisodeprivacidad",
  },
  {
    path: "avisodeprivacidad",
    name: "avisodeprivacidad",
    component: () => import("@/views/Information/privacyPolicy.vue"),
    meta: {
      title: "隐私政策",
    },
  },
  {
    path: "termsAndAgreement",
    name: "termsAndAgreement",
    component: () => import("@/views/Information/termsAndAgreement.vue"),
    meta: {
      title: "使用条款",
    },
  },
  {
    path: "notice",
    name: "notice",
    component: () => import("@/views/Information/notice.vue"),
    meta: {
      title: "公告",
    },
  },
];
